module.exports = "<div class=calendar-week-comment> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/bisystem/canvas/main/cells/cell/calendar/calendar.small/calendar.small.week/calendar.small.week.html
// module id = 4916
// module chunks = 50